import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Vimeo from 'react-vimeo';

import { toVw, transitionDefault } from '../utils/styles';
import { TRANSITION_DURATION, TRANSITION_FUNCTION } from '../constants';
import { observer, inject } from 'mobx-react';

const Styled = styled.div`
  position: relative;
  padding-bottom: 56.25%;

  .vimeo-image {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-size: cover;

    .vimeo-play-button {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      //top: 50%;
      //left: 50%;
      background-color: transparent;
      border: none;
      cursor: pointer;

      //&:hover {
      //	svg {
      //		transform: scale(1.1);
      //		transition-duration: 0.1s;
      //	}
      //}

      &:focus {
        outline: none;
      }

      //&:active {
      //	svg {
      //		transform: scale(1.2);
      //		opacity: 0;
      //	}
      //}

      svg {
        ${transitionDefault};
        width: ${toVw(40)};
        fill: #85ff00;
        will-change: transform;
        transition: transform ${TRANSITION_DURATION} ${TRANSITION_FUNCTION};
      }
    }
  }

  .vimeo-embed {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 100;

    iframe {
      height: 100%;
      width: 100%;
    }
  }
`;

class VimeoVideo extends React.Component {
  static propTypes = {
    cursorStore: PropTypes.object.isRequired,
  };

  componentDidMount() {
    this.containerNode.addEventListener('click', this.clickHandler);
  }

  componentWillUnmount() {
    this.containerNode.removeEventListener('mouseenter', this.mouseEnterHandler);
    this.containerNode.removeEventListener('mouseleave', this.mouseLeaveHandler);
    this.containerNode.removeEventListener('click', this.clickHandler);
  }

  mouseEnterHandler = () => {
    this.props.cursorStore.setHidden();
  };

  mouseLeaveHandler = () => {
    this.props.cursorStore.setNone();
  };

  clickHandler = () => {
    this.containerNode.addEventListener('mouseenter', this.mouseEnterHandler);
    this.containerNode.addEventListener('mouseleave', this.mouseLeaveHandler);
    this.props.cursorStore.setHidden();
  };

  render() {
    return (
      <Styled innerRef={node => (this.containerNode = node)} data-hover-play>
        <Vimeo {...this.props} />
      </Styled>
    );
  }
}

export default inject(stores => ({ cursorStore: stores.store.cursorStore }))(observer(VimeoVideo));



// WEBPACK FOOTER //
// ./src/components/VimeoVideo.js